import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["upgradePageKey", "children"];
import { Button } from 'foundations-components/transitional/components/Button';
import { useUpgradePoint } from 'ui-addon-upgrades/ums/useUpgradePoint';
import { jsx as _jsx } from "react/jsx-runtime";
export const UpgradeButton = _ref => {
  let {
      upgradePageKey,
      children
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    openUpgradePage
  } = useUpgradePoint(upgradePageKey);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    onClick: e => {
      var _buttonProps$onClick;
      (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 || _buttonProps$onClick.call(buttonProps, e);
      openUpgradePage();
    },
    children: children
  }));
};